import { CILogger } from 'common/log/log.provider';

import { DEVICE_HANDOFF_STORAGE_KEY } from './constants';
import type { DeviceHandoffState } from './types';

const INACTIVE_STATE: DeviceHandoffState = { phase: 'inactive' };

function safeParse<T>(raw: string | null, context: string): T | null {
    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw) as T;
    } catch (error) {
        CILogger.getInstance().error(`device handoff: failed to parse ${context}`, error);

        return null;
    }
}

export function readPersistedDeviceHandoff(): DeviceHandoffState {
    const persisted = safeParse<DeviceHandoffState>(
        localStorage.getItem(DEVICE_HANDOFF_STORAGE_KEY),
        'persisted device handoff state'
    );

    return persisted ?? INACTIVE_STATE;
}

export function persistDeviceHandoff(state: DeviceHandoffState): void {
    if (state.phase === 'inactive') {
        clearDeviceHandoff();

        return;
    }

    localStorage.setItem(DEVICE_HANDOFF_STORAGE_KEY, JSON.stringify(state));
}

export function clearDeviceHandoff(): void {
    localStorage.removeItem(DEVICE_HANDOFF_STORAGE_KEY);
}

export function subscribeToCrossTab(onChange: (state: DeviceHandoffState) => void): () => void {
    const listener = (event: StorageEvent): void => {
        if (event.key !== DEVICE_HANDOFF_STORAGE_KEY) {
            return;
        }

        onChange(safeParse<DeviceHandoffState>(event.newValue, 'cross-tab device handoff state') ?? INACTIVE_STATE);
    };

    window.addEventListener('storage', listener);

    return () => window.removeEventListener('storage', listener);
}
